import { useEffect, useState } from "react";
import { Form } from "../../common/Form";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { CommonDialog } from "../../common/CommonDialog";
import { colorList, jwordFontList, jwordFontSizeList } from "./jword-config";
import { useTranslation } from "react-i18next";

export function FontDialog({charProps,visible,onOK,onCancel})
{
    const {t} = useTranslation();     
    const [fontInfo,setFontInfo]=useState();

    const onChange=(formData)=>{
        setFontInfo(formData);
    };
    const _onCancel=()=>{
        onCancel();
    };
    const _onOK=()=>{
        onOK(fontInfo);
    };
    useEffect(()=>{
        //console.log("charProps:"+JSON.stringify(fontInfo));
        setFontInfo({...charProps});
    },[charProps]);
    return(
        <>
        <CommonDialog header={t('Editor.Font_Settings')} visible={visible} onOK={_onOK} onCancel={_onCancel}>
            <div style={{maxWidth:'400px'}}>
            <Form id="formatFont" formData={fontInfo} columns="1" onChange={onChange}
                fields={[
                    {id:"face",ftype:"dropdown",field:"face",label:t('Editor.Font_Type'),options:jwordFontList,optionLabel:"family",optionValue:"family"},
                    {id:"size",ftype:"dropdown",field:"size",label:t('Editor.Font_Size'),options:jwordFontSizeList}
                ]}>
            </Form>	
            <Form id="formatFont2" formData={fontInfo} columns="2" onChange={onChange}
                fields={[
                    {id:"bold",ftype:"checkbox",field:"bold",label:t('Editor.Bold')},
                    {id:"italic",ftype:"checkbox",field:"italic",label:t('Editor.Italic')},
                    {id:"uline",ftype:"checkbox",field:"uline",label:t('Editor.Underline')},
                    {id:"strike",ftype:"checkbox",field:"strike",label:t('Editor.Strike_through')},
                    {id:"sub",ftype:"checkbox",field:"sub",label:t('Editor.Subscript')},
                    {id:"sup",ftype:"checkbox",field:"sup",label:t('Editor.Superscript')},
                    {id:"color",ftype:"color",field:"color",label:t('Editor.Text_Color'),options:colorList},                    
                    {id:"backColor",ftype:"color",field:"backColor",label:t('Editor.Background'),options:colorList}
            ]}>
            </Form>	
            </div>
        </CommonDialog>
        </>
    );
}